define([
], () => {
  const APP_ID = 'launcher';

  const SLUG_TO_FEATURE = {
    'service': {
      title: 'Service',
      feature: 'services',
    },
  };

  const SUMO_STORE_ID = 'c9a64ad6-0863-4b66-bc0c-ef0fb5ef15d0';
  const SETTINGS_ID = '5d26e2da-aef5-41c1-947a-624497281723';
  const SHARE_APP_UUID = '9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1';
  const DASHBOARD_APP_UUID = '8a92832c-ad3b-4d7a-9154-22856aa1d9e9';
  const IMAGE_SHARER_APP_UUID = '55c989d5-855d-4538-b67b-3cdb46acd968';
  const LIST_BUILDER_3_APP_UUID = '156085c5-0017-4150-b225-a731ad248f38';
  const SHORTCUTS_APP_UUID = 'c3da7147-2536-4768-af12-50317edc18ae';
  const SHORTCUTS_DISCOUNT_CODE = 'shortcuts-free-trial';

  const SIDEBAR_ITEMS = [
    {
      name: 'Dashboard',
      subItems: [
        {
          name: 'Dashboard',
          appId: 'dashboard',
          isCore: 'true',
        },
      ],
    },
    {
      name: 'Campaigns',
      subItems: [
        {
          name: 'List Builder',
          appId: 'listbuilder',
        },
        {
          name: 'List Builder',
          appId: 'listbuilder-legacy',
        },
        {
          name: 'Welcome Mat',
          appId: 'welcome-mat',
        },
        {
          name: 'Smart Bar',
          appId: 'smart-bar',
        },
        {
          name: 'Scroll Box',
          appId: 'scrollbox',
        },
        {
          name: 'Contact Form',
          appId: 'contact-form',
        },
      ],
    },
    {
      name: 'Emails',
      appId: 'messages',
      subItems: [
        {
          name: 'Campaigns',
          appId: 'messagecenter',
          isCore: true,
        },
      ],
    },
    {
      name: 'Monetize',
      subItems: [{
        name: 'Discounts',
        appId: 'discounts',
        isCore: true,
      }, {
        name: 'Shortcuts',
        appId: 'shortcuts',
        isCore: true,
      }],
    },
    {
      name: 'Contacts',
      appId: 'subscribers',
    },
    {
      name: 'Extras',
      subItems: [
        {
          name: 'Share',
          appId: 'share',
        },
        {
          name: 'Image Sharer',
          appId: 'image-sharer',
        },
      ],
    },
  ];

  const NOTIFICATIONS_APP_ID = 'notifications';
  const NOTIFICATIONS_APP_UUID = 'ee27a0af-9947-40c9-8eab-0ab6a4f7a9c1';
  const MESSAGECENTER_APP_ID = 'messagecenter';
  const APP_STORE_ID = 'c9a64ad6-0863-4b66-bc0c-ef0fb5ef15d0';
  const COUNTDOWN_PLACEHOLDER = '[24hrCountdown]';
  const NOTIFICATION_HEIGHT = 60;

  // Chat
  const CHAT_APP_ID = 'chat';
  const CHAT_APP_UUID = 'def79cfc-384b-45dd-b6b0-71ee6639860d';
  const CHAT_OBJECT_ID = 'f5104759-c678-40f2-8809-add44b178274';

  const DEFAULT_CAMPAIGN_FILTERS = {
    statuses: {
      draft: { enabled: true, label: 'Draft' },
      scheduled: { enabled: true, label: 'Scheduled' },
      queued: { enabled: true, label: 'Queued' },
      sending: { enabled: true, label: 'Sending' },
      sent: { enabled: true, label: 'Sent' },
      deleted: { enabled: false, label: 'Deleted' },
    },
    campaignTypes: {
      email: { enabled: true, label: 'Email' },
      push: { enabled: true, label: 'Push' },
    },
    autoresponse: {
      active: { enabled: true, label: 'Active' },
      paused: { enabled: true, label: 'Paused' },
    },
  };

  const STATUS_DEFAULT_ENABLED = ['draft', 'scheduled', 'queued', 'sending', 'sent'];

  const CampaignTypes = [
    { label: 'Email', value: 'email' },
    { label: 'Push Notification', value: 'push' },
  ];

  const CAMPAIGN_FILTER_ORDER = [{
    type: 'statuses',
    order: ['draft', 'scheduled', 'queued', 'sending', 'sent', 'deleted'],
  }, {
    type: 'autoresponse',
    order: ['active', 'paused'],
  }, {
    type: 'campaignTypes',
    order: ['email', 'push'],
  }];

  // Subscribers
  const SUBSCRIBERS_APP_ID = 'subscribers';
  const SUBSCRIBERS_APP_UUID = 'c0b81e54-d408-4ee2-911b-46108f8b6e66';
  const SearchFilters = [
    {
      key: 'email',
      label: 'Email Address',
      filters: [
        { key: 'contains', label: 'contains' },
      ],
    }, {
      key: 'name',
      label: 'Name',
      filters: [
        { key: 'contains', label: 'contains' },
      ],
    }, {
      key: 'created',
      label: 'Signed Up',
      filters: [
        { key: 'is', label: 'on', type: 'date' },
        { key: 'before', label: 'before', type: 'date' },
        { key: 'after', label: 'after', type: 'date' },
      ],
    }, {
      key: 'country',
      label: 'Country',
      filters: [
        { key: 'is', label: 'is' },
      ],
    }, {
      key: 'source',
      label: 'Source',
      filters: [
        { key: 'is', label: 'is' },
      ],
    }, {
      key: 'type',
      label: 'Type',
      filters: [
        { key: 'exists', label: 'exists' },
      ],
    },
  ];

  const DEFAULT_COLORS = {
    backgroundColor: 'rgba(67,151,236,1)',
    chatBubbleColor: 'rgba(195,220,236,1)',
    chatBackgroundColor: 'rgba(234,240,245,1)',
    fontColor: 'rgba(73,82,89,1)',
  };

  const TRANSPARENT_MIMETYPES = ['image/png', 'image/gif'];

  const VALID_IMAGE_TYPES = [
    'image/jpeg',
    'image/png',
    'image/x-png',
    'image/gif',
    'image/bmp',
    'image/svg+xml',
  ];

  const SHORTCUTS_PLATFORMS = [
    'shopify',
    'woocommerce',
  ];

  const SHORTCUT_TEMPLATE_ID_ABANDONED_CART = 'd1b28f5d-d834-4eab-bed8-505338512f5d';
  const SHORTCUT_TEMPLATE_ID_GROW_EMAIL = '7b743121-fbf3-498a-8310-922af34b2560';
  const SHORTCUT_TEMPLATE_ID_CUSTOMER_OUTREACH = '3897cf38-9205-4ea4-9731-abaa14593f62';

  const SHORTCUT_PLACEHOLDER_PRODUCT_TAGS = {
    product_title: 'Extended Oversized Longsleeve Gray Sweat Shirt',
    product_desc: 'Keep it classic in this vintage crew-neck tee made from 100% cotton in a shrunken top-of-the-jean length.',
    product_desc_more_display: 'none',
    product_image: 'https://media.sumome.com/0f3a8905dc38b006768f17372a2d911b588db048d3f620d2e7d1a4500875dfae',
    product_price: '$20.99',
  };

  const SHORTCUT_CUSTOM_EMAIL_TYPES = [
    'customer-outreach',
    'product-view',
  ];

  return {
    APP_ID,
    SLUG_TO_FEATURE,
    SUMO_STORE_ID,
    SETTINGS_ID,
    SHARE_APP_UUID,
    DASHBOARD_APP_UUID,
    IMAGE_SHARER_APP_UUID,
    LIST_BUILDER_3_APP_UUID,
    SHORTCUTS_APP_UUID,
    SIDEBAR_ITEMS,

    NOTIFICATIONS_APP_ID,
    NOTIFICATIONS_APP_UUID,
    APP_STORE_ID,
    COUNTDOWN_PLACEHOLDER,
    NOTIFICATION_HEIGHT,

    MESSAGECENTER_APP_ID,
    CAMPAIGN_FILTER_ORDER,
    DEFAULT_CAMPAIGN_FILTERS,
    STATUS_DEFAULT_ENABLED,

    SUBSCRIBERS_APP_ID,
    SUBSCRIBERS_APP_UUID,
    SearchFilters,

    CHAT_APP_UUID,
    CHAT_APP_ID,
    CHAT_OBJECT_ID,
    DEFAULT_COLORS,
    TRANSPARENT_MIMETYPES,
    VALID_IMAGE_TYPES,
    SHORTCUTS_PLATFORMS,

    SHORTCUT_TEMPLATE_ID_ABANDONED_CART,
    SHORTCUT_TEMPLATE_ID_GROW_EMAIL,
    SHORTCUT_TEMPLATE_ID_CUSTOMER_OUTREACH,

    SHORTCUTS_DISCOUNT_CODE,
    SHORTCUT_PLACEHOLDER_PRODUCT_TAGS,
    SHORTCUT_CUSTOM_EMAIL_TYPES,

    CampaignTypes,
  };
});
